module.exports = __webpack_public_path__ + "img/p4_2.0a35db62.webp";